import React, { useState } from 'react';
import {
  Base, WithSentry, RecoveryForm, ReturnToApp,
} from './components';
import './App.css';

const App = () => {
  const [success, setSuccess] = useState(false);
  return (
    <Base>{success ? <ReturnToApp /> : <RecoveryForm setSuccess={setSuccess} /> }</Base>
  );
};

export default WithSentry(App);
